<div class="row">
  <div class="col-lg col-lg-12 mb-3">
    <h4 class="fs-16 font-weight-bold">What are cookies?</h4>
    <p class="fs-12">
      This Cookie Policy explains what cookies are and how we use them, the types of cookies we use i.e, the information we collect using cookies and how that information is used, and how to manage the cookie settings.
    </p>
    <p class="fs-12">
      Cookies are small text files that are used to store small pieces of information. They are stored on your device when the website is loaded on your browser. These cookies help us make the website function properly, provide better user experience.
    </p>
  </div>

  <div class="col-lg col-lg-12 mb-3">
    <h4 class="fs-16 font-weight-bold">How do we use cookies?</h4>
    <p class="fs-12">
      As most of the online services, our website uses first-party cookies for several purposes. First-party cookies are mostly necessary for the website to function the right way.
    </p>
  </div>

  <div class="col-lg col-lg-12">
    <h4 class="fs-16 font-weight-bold">Types of Cookies we use</h4>
    <p class="fs-12">
      Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences.
    </p>

    <h5 class="fs-14 font-weight-bold mb-2">Necessary:</h5>

    <ng-container *ngFor="let option of cookiesOptions">
      <div class="mb-2">
        <input type="checkbox" checked disabled />
        <p class="d-inline px-2 fs-12">{{ option }}</p>
      </div>
    </ng-container>
  </div>
</div>
